// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--2B6lc","postfix":"_93444fe79c--postfix--1lZG5"};